import { CLOSE_HELP, SHOW_HELP, RESET_HELP_SECTION_TOPIC } from '@app/actions/_types';
import {
  UPLOAD_ART_VIEW,
  CUSTOMIZE_VIEW,
  APPLY_CODES_VIEW,
  WHITE_INK_OPTIONS_VIEW,
  UPLOAD_CODES_FLOW,
  LOGIN_SIGNUP_FLOW,
  REQUEST_CODES_FLOW,
  AUTHORIZE_CODES_FLOW,
  APPLY_CODES_FLOW_SELECTION,
  HELP_SECTION_UPLOAD_ART,
  HELP_SECTION_ART_SIZE_POSITION,
  HELP_SECTION_WHITE_INK,
  HELP_TOPIC_APPLY_CODES,
  HELP_TOPIC_APPLY_CODES_SIGN_IN,
  HELP_TOPIC_APPLY_CODES_UPLOAD_CODES,
  HELP_TOPIC_APPLY_CODES_REQUEST_CODES,
  HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES,
  HELP_SECTION_UPLOAD_CODES,
  HELP_SECTION_REQUEST_CODES,
} from '@app/constants';

export const closeHelp = () => ({
  type: CLOSE_HELP,
});

export const resetHelpSectionTopic = () => ({
  type: RESET_HELP_SECTION_TOPIC,
});

export const showHelp = (helpSection, helpTopic, triggerElement = null) => ({
  type: SHOW_HELP,
  payload: { helpSection, helpTopic, triggerElement },
});

export const toggleHelp = (triggerElement = null) => (dispatch, getState) => {
  const {
    matrix: { view },
    help: { activated: helpActive },
    applyCodes: { applyCodesStep },
  } = getState();
  const prevView = sessionStorage.getItem('prevView');

  const helpSectionByView = {
    [UPLOAD_ART_VIEW]: HELP_SECTION_UPLOAD_ART,
    [CUSTOMIZE_VIEW]: HELP_SECTION_ART_SIZE_POSITION,
    [APPLY_CODES_VIEW]: applyCodesStep === UPLOAD_CODES_FLOW ? HELP_SECTION_UPLOAD_CODES : HELP_SECTION_REQUEST_CODES,
    [WHITE_INK_OPTIONS_VIEW]: HELP_SECTION_WHITE_INK,
  };

  const helpTopicByApplyCodesStep = {
    [UPLOAD_CODES_FLOW]: HELP_TOPIC_APPLY_CODES_UPLOAD_CODES,
    [REQUEST_CODES_FLOW]: HELP_TOPIC_APPLY_CODES_REQUEST_CODES,
    [AUTHORIZE_CODES_FLOW]: HELP_TOPIC_APPLY_CODES_AUTHORIZE_CODES,
    [APPLY_CODES_FLOW_SELECTION]: HELP_TOPIC_APPLY_CODES,
    [LOGIN_SIGNUP_FLOW]: HELP_TOPIC_APPLY_CODES_SIGN_IN,
  };

  const isApplyCodesView = view === APPLY_CODES_VIEW;
  const helpSection = helpSectionByView[prevView || view];
  const helpTopic = isApplyCodesView ? helpTopicByApplyCodesStep[applyCodesStep] : null;

  dispatch(helpActive ? closeHelp() : showHelp(helpSection, helpTopic, triggerElement));
};
